import { Tooltip, TooltipProps } from "antd"
import { MediaQueryContext } from "libs/contexts"
import { useContext } from "react"
import { Icon } from "react-vant"
import { cls } from "reactutils"

export default function QuestionIcon({
  onClick,
  title,
  arrowPointAtCenter = true,
  placement = "top",
  ...tooltipProps
}: {
  onClick: () => void
  title: React.ReactNode
} & TooltipProps) {
  const { isMobile } = useContext(MediaQueryContext)
  return (
    <>
      <Tooltip
        placement={placement}
        arrowPointAtCenter
        {...tooltipProps}
        trigger={isMobile ? [] : "hover"}
        title={<div className="title-container">{title}</div>}
        overlayStyle={{
          maxWidth: "unset",
        }}
      >
        <span
          className={cls("question-icon-container", isMobile ? "h5" : "pc")}
          onClick={() => {
            if (isMobile) {
              onClick()
            }
          }}
        >
          <Icon name="question-o" />
        </span>
      </Tooltip>
      <style jsx>{`
        .title-container {
          font-size: 12px;
        }
        .question-icon-container.pc {
          cursor: pointer;
        }
        .question-icon-container.pc:hover :global(.van-icon) {
          color: var(--primaryColor);
        }
      `}</style>
    </>
  )
}
